export default function checkAuthorization (currentUserData, currentProject, textContainer, customizedFunction){
  try{
        const actualProject = 
          currentUserData.currentUser.accessAuthorizations
            .find(el => el.id === currentProject.central.project_id)
        if (!actualProject) throw 'No Projects were found'
        if (!actualProject.canPerformActions){
          textContainer.innerHTML = 'Der Benutzer hat keine Berechtigungen'
        }else{
          customizedFunction()
        }
      }catch(err){
        console.log(err)
    }

    return ;

}